import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.catalogFields],
        config: {
            headerName: "",
            checkboxSelection: true,
            headerCheckboxSelection: true,
            width: 32,
            minWidth: 32,
            maxWidth: 32,
            enableRowGroup: true,
            sortable: false,
            filter: false,
            suppressMenu: true,
            resizable: false,
            editable: false,
        },
    },
    {
        pages: [paths.catalogFields],
        config: {
            headerName: getLocalizedString("physicalTableCode"),
            field: "physicalCode",
            filter: "agSetColumnFilter",
            chartDataType: "series",
        }
    },
    {
        pages: [paths.catalogFields],
        config: {
            headerName: getLocalizedString("physicalCodeOfField"),
            field: "fieldCode",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.catalogFields],
        config: {
            headerName: getLocalizedString("fieldNameAlt"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.catalogFields],
        config: {
            headerName: getLocalizedString("type"),
            field: "type",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.catalogFields],
        config: {
            headerName: getLocalizedString("size"),
            field: "size",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.catalogFields],
        config: {
            headerName: getLocalizedString("hasAssociatedValues"),
            field: "hasOptions",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.catalogs],
        config: {
            headerName: getLocalizedString("catalogTableCode"),
            field: "code",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.catalogs],
        config: {
            headerName: getLocalizedString("tableName"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.catalogs],
        config: {
            headerName: getLocalizedString("physicalTableCode"),
            field: "physicalCode",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.catalogs],
        config: {
            headerName: getLocalizedString("tableType"),
            field: "type",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.catalogs],
        config: {
            headerName: getLocalizedString("hasRelatedEditors"),
            field: "hasRelatedEditors",
            filter: "agSetColumnFilter",
        }
    },
]